import type { HoverPointerSnapshot, HoverRectLike } from "./hoverPointerTypes";

export function resolveHoverActive(
  pointer: HoverPointerSnapshot,
  rect: HoverRectLike,
): boolean {
  const position = pointer.position;
  if (position === null) {
    return false;
  }
  return (
    position.x >= rect.left &&
    position.x < rect.right &&
    position.y >= rect.top &&
    position.y < rect.bottom
  );
}
